import { zodResolver } from "@hookform/resolvers/zod";
import { type CreateSeriesInput, createSeriesSchema, Genre } from "@storyline/shared";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { HttpError } from "@/src/common/services/api-error";
import { createSeries } from "@/src/series/services/series-http.service";

const GENERIC_ERROR = "La création a échoué. Veuillez réessayer.";

export const useCreateSeries = (onCreated: (seriesId: string) => void) => {
	const [error, setError] = useState<string | null>(null);
	const form = useForm<CreateSeriesInput>({
		resolver: zodResolver(createSeriesSchema),
		defaultValues: { title: "", synopsis: "", genre: Genre.HORROR },
	});

	const submit = form.handleSubmit(async (body) => {
		setError(null);
		try {
			const created = await createSeries(body);
			form.reset();
			onCreated(created.id);
		} catch (caught) {
			setError(caught instanceof HttpError ? caught.message : GENERIC_ERROR);
		}
	});

	return { form, submit, error, isSubmitting: form.formState.isSubmitting };
};
